import { Component, OnInit,OnDestroy, ElementRef, ViewChild , Renderer2} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { IMyDpOptions } from 'mydatepicker';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { EchexbaseComponent } from '../echexbase/echexbase.component';
import { EchexpaymentService } from '../echexpayment.service';
import { LocalstorageService } from '../localstorage.service';
import { UserService } from '../user.service';

@Component({
  selector: 'app-create-invoice',
  templateUrl: './create-invoice.component.html',
  styleUrls: ['./create-invoice.component.css']
})
export class CreateInvoiceComponent  extends EchexbaseComponent implements OnInit , OnDestroy{
    @ViewChild('e') iu : NgForm;
    public createInvoice: any={};
	public token: string;
	public user_id: string;
    public merchant_id: string;
	busy: Subscription;
	public today_date : string;
	public invalidEmalAddress : boolean = false;
    // public Business_name : string;
    public formTouched : boolean = false;
    public invoicesData: any=[];
    public userFirstName : string;
    public userLastName : string;
    public isRecurring : boolean = false;
    public interval : number = 1;
    public pay_type : number = 1;
    // public selectedImage: string;
    public fileValidate: boolean = false;
    public singleData: any=[];
    public NamecharacterLimitReached: { [key: string]: boolean } = {};
    public characterLimitReached : boolean = false;
    public showWarning: boolean = false;
    public formSubmit: boolean = false; 
    public fileToUpload: File = null;
    public advancedata: any = {};
    public DateValidate : string;
    public DateValidateSingle : string;
	public myDatePickerOptions: IMyDpOptions = {
        dateFormat: 'dd/mm/yyyy',
        openSelectorTopOfInput:true,
        editableDateField:false
    };


     //recuring
    public filterQuery = "";
    public rowsOnPage = 10;
    public sortBy = "";
    public sortOrder = "DESC";
	
	constructor(protected router: Router, protected route: ActivatedRoute, protected toastr: ToastrService,private renderer: Renderer2, protected userService:UserService, protected echexpaymentService :EchexpaymentService, protected localStorageService: LocalstorageService, private elementRef: ElementRef) { 
        super(route, router, toastr, userService, echexpaymentService, localStorageService);

        this.router = router;
        var currentUser = this.localStorageService.getData("currentUserToken");
        this.token =  currentUser.data.user_token;
        
        let userDetails = this.localStorageService.getData("currentUser");
        this.user_id = userDetails._id;
        this.merchant_id = userDetails.merchant_token;
        // this.Business_name = userDetails.business_name;
        this.userFirstName = userDetails.first_name;
        this.userLastName = userDetails.last_name;
        // this.today_date =  new Date();
        const date = new Date();
        const monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];

        let day = date.getDate();
        let month = monthNames[date.getMonth()];
        let year = date.getFullYear();

        // This arrangement can be altered based on how we want the date's format to appear.
        this.today_date = `${month} ${day}, ${year}`;
	}

    focusFirstInvalidControlPlus(): void {
        const firstElementWithErrors: HTMLElement = this.elementRef.nativeElement.querySelector(`form .ng-invalid`);
        if (firstElementWithErrors) {
            firstElementWithErrors.focus();
        }
    }

    ngOnDestroy() {
        this.toastr.clear();
    }

	ngOnInit() {
        // this.createInvoice.is_recurring = 0;
        this.createInvoice.duration = 0;
        this.advancedata.Selectfilter = '';
        this.advancedata.Statusfilter = '';
        this.getInvoiceList(); 
	}

    onChange(e) {
        this.interval= e.target.value;
    }

    onChangePayType(e) {
        this.pay_type= e.target.value;
    }
	
	eventHandler(){
        this.invalidEmalAddress = false;
    }

    DisallowZero(event: any) {
        const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
        const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
    
        if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
            // Allow the default behavior for certain keys
            return;
        }
    
        const inputValue = event.target.value;
        const caretStart = event.target.selectionStart;
        const caretEnd = event.target.selectionEnd;
        const modifiedValue = inputValue.slice(0, caretStart) + event.key + inputValue.slice(caretEnd);
    
        if (modifiedValue !== '' && !/^\d*\.?\d*$/.test(modifiedValue)) {
            this.showWarning = false; // Hide the warning message
            event.preventDefault(); // Prevent invalid input
            return;
        }
        const regex = /^\d{0,9}(\.\d{0,2})?$/;
        const maxValue = 999999999;
        if (!regex.test(modifiedValue) || parseFloat(modifiedValue) > maxValue) {
            if (parseFloat(modifiedValue) > maxValue) {
                this.showWarning = true;
                setTimeout(() => {
                    this.showWarning = false;
                }, 3000);
                event.preventDefault();
            }
            event.preventDefault();
        }
    }

	// Save send an invoice
	savecreateInvoice(data){
        this.focusFirstInvalidControlPlus();
        this.formTouched = true;

        if(data.valid && !this.fileValidate){
            let model: any = data.value;
            model.user_token = this.token;
            model.user_id =  this.user_id;
            model.merchant_id =  this.merchant_id;
            model.interval = this.interval;
            model.pay_type = this.pay_type;
            model.is_recurring = (this.isRecurring ? 1 : 0);
            if(model.start_date) {
                const currentDate = new Date(); // Get the current date
                currentDate.setHours(0, 0, 0, 0);
                const startDate = model.start_date && model.start_date.jsdate ? new Date(model.start_date.jsdate) : null;

                if (startDate <= currentDate) {
                    this.DateValidateSingle = "Start date must be greater than the current date.";
                    return;
                } else {
                    this.DateValidateSingle = "";
                }
                model.start_date = model.start_date.formatted;
            } else {
                model.start_date = '';
            }

            const formData = new FormData();
            if (this.fileToUpload) {
                formData.append('invoice_document', this.fileToUpload); 
            }

            Object.entries(model).forEach(([key, value]) => {
                formData.append(key, value as any);
            });

            this.formSubmit = true;
            let responseData = <any>{};
            this.busy = this.userService.createEchexInvoice(model, formData).subscribe(
                response => {
                    responseData = response;
                    this.toastr.success(responseData.message, 'Success!');
                    // this.createInvoice.payor_name = '';
                    // this.createInvoice.payor_email = '';
                    // this.createInvoice.amount = '';
                    // this.createInvoice.memo = '';
                    // this.createInvoice.is_recurring = 0;
                    // this.interval = 1;
                    // this.createInvoice.start_date = '';
                    this.iu.reset();
                    this.fileToUpload = null;
                    this.createInvoice.is_recurring = false;
                    this.isRecurring = false;
                    this.createInvoice.duration = 0;
                    this.getInvoiceList();
                    this.formTouched = false;
                    this.formSubmit = false;
                },
                error => {
                    this.formSubmit = false;
                    responseData = error;
                    this.toastr.error(responseData.error.message, 'Failed!');
                }
            );
        }
    }

    //setAmountValue
    setAmountValue(amount){
        if(amount) {
            this.createInvoice.amount = parseFloat(amount).toFixed(2);
        }
    }

    showRecurringDiv(event) {
        if(event.currentTarget.checked) {
            this.isRecurring = true;
        } else {
            this.isRecurring = false;
        }
    }

    // get user by merchant
    getInvoiceList(){
        var data = {
            token:this.token,
            user_id:this.user_id
        }
        var url =  this.router.url;
        let response_users = <any>{};
        this.busy = this.userService.getInvoiceUsersAPI(data).subscribe(
            response => {
                response_users = response;
                this.invoicesData = response_users.data;
            },
            error => {
                response_users = error;
                this.toastr.error(response_users.error.message, 'Failed!');
            }
        );
    }

    handleFileInput(files: FileList) {
        if (files.length === 0) {
            return;
        } 
  
        const allowedFileTypes = [
            'application/pdf',
            'pdf'
        ];

        const file = files[0];
        if (!allowedFileTypes.includes(file.type)) {
            this.fileValidate = true;
            return;
        } else{
            this.fileValidate = false;
        }

        this.fileToUpload = files.item(0);
    }

    displayStyle = "none";
  
    openPopup(invoice_id) {
        this.displayStyle = "block";
        this.singleData = [];
        var data = {
            token:this.token,
            user_id:this.user_id,
            id: invoice_id
        }
        let response_users = <any>{};
        this.busy = this.userService.getSingleInvoice(data).subscribe(
            response => {
                response_users = response;
                this.singleData = response_users.data;
            },
            error => {
                response_users = error;
                this.toastr.error(response_users.error.message, 'Failed!');
            }
        );
    }
        
    closePopup() {
        this.displayStyle = "none";
    }

     // force download file
    downloadFile(url, name) {
        fetch(url)
            .then(resp => resp.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                // the filename you want
                a.download = name;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            })
        .catch(() => alert('An error sorry'));
    }

    // get transcation data for advanced tab
	getAllTransactionAdvance(model:any = {}, search_but:any = '')
	{
		model.status_filter = this.advancedata.Statusfilter;
		if(search_but === 1) {
			//date validate
			const fromDate = this.advancedata.from_date && this.advancedata.from_date.jsdate ? new Date(this.advancedata.from_date.jsdate) : null;
			const toDate = this.advancedata.to_date && this.advancedata.to_date.jsdate ? new Date(this.advancedata.to_date.jsdate) : null;
			const currentDate = new Date(); // Get the current date

			currentDate.setHours(0, 0, 0, 0);
			if (fromDate && toDate && fromDate.getTime() === toDate.getTime()) {
				this.DateValidate = "From date and To date cannot be the same.";
				//   return;
			} else if (fromDate && toDate && fromDate > toDate) {
				this.DateValidate = "From date must be less than the To date.";
				return;
			} else if (fromDate && toDate && fromDate == null || toDate == null) {
				this.DateValidate = "For Search Select - From date and To Date";
				return;
			} else {
				this.DateValidate = "";
			} 
			
			if (toDate > currentDate) {
				this.DateValidate = "To date must be less than or equal to the current date.";
				return;
			} else {
				this.DateValidate = "";
			}
		}
		
		model.user_id = this.user_id;
		model.merchant_id = this.merchant_id;
		model.token = this.token;

		if(this.advancedata.from_date && this.advancedata.to_date) {
			model.from_date = this.advancedata.from_date.formatted;
			model.to_date = this.advancedata.to_date.formatted;
		}

		let responseData = <any>{};
        this.busy = this.userService.getInvoiceUsersAPI(model).subscribe(
	        response => {
                responseData = response;
                //Transction filter added
                this.invoicesData = responseData.data;  
	        },
	        error => {
	            responseData = error;
			    this.toastr.error(responseData.error.message, 'Failed!');
	        }
	    );
	}

    @ViewChild('submitButton') submitButton: ElementRef;
    @ViewChild('StartDate') inputEl: ElementRef;
    moveNext(nextInput: HTMLInputElement, checkbox : number) {
        if(checkbox === 2){
            if (this.submitButton && this.submitButton.nativeElement) {
                this.submitButton.nativeElement.focus();
                this.submitButton.nativeElement.click();
            }
        } if(checkbox === 3){
            // console.log(this.inputEl.nativeElement);
            // const element = this.renderer.selectRootElement('#StartDate');
            setTimeout(() => this.renderer.selectRootElement(this.inputEl.nativeElement).focus(), 0);
            // this.inputEl.nativeElement.focus();
            // if (dateTextInput) {
            //     dateTextInput.focus();
            // }
        } else {
            nextInput && nextInput.focus();
        }
    }

    @ViewChild('Focus_monthly') weeklyInput : ElementRef;
    checkRecurring(event: any){
        if(event.target.checked){
            this.weeklyInput.nativeElement.focus();
           // this.renderer.selectRootElement('#Focus_weekly').focus();
        }else{
            this.renderer.selectRootElement('#BankAuth').focus();
        }
    }

    NameCharacterLimit(event: any, fieldName: string, max_length:number) {
        const maxTextLength = max_length; // Maximum text length of 20 characters
        const inputChar = event.key;
        const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
        const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
    
        if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
            return;
        }
    
        const inputValue = event.target.value;
    
        if (inputValue.length >= maxTextLength) {
            if (allowedKeys.indexOf(inputChar) === -1) {
                this.NamecharacterLimitReached[fieldName] = true; // Set the validation flag to true to show the warning message
                setTimeout(() => {
                this.NamecharacterLimitReached[fieldName] = false; // Hide the warning message after 3 seconds
                }, 3000);
                event.preventDefault(); // Prevent entering the exceeded character
            }
        }
    }
    
    isNameLimitReached(fieldName: string): boolean {
        return this.NamecharacterLimitReached[fieldName];
    }

    checkCharacterLimit(event: any) {
		const maxTextLength = 20; // Maximum text length of 20 characters
		const inputChar = event.key;
		const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
		const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
	  
		if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
		    return;
		}
		const inputValue = event.target.value;
		
		if (inputValue.length >= maxTextLength) {
		    if (allowedKeys.indexOf(inputChar) === -1) {
		        this.characterLimitReached = true; // Set the validation flag to true to show the warning message
		        setTimeout(() => {
			        this.characterLimitReached = false; // Hide the warning message after 3 seconds
		        }, 3000);
		        event.preventDefault(); // Prevent entering the exceeded character
		    }
		}
	}

    limitDecimalLength(inputElement: HTMLInputElement) {
        const regex = /^\d{0,9}(\.\d{0,2})?$/;
        const inputValue = inputElement.value;
        
        if (!regex.test(inputValue)) {
            inputElement.value = inputValue.slice(0, -1);
        }
    }

    resendEmail(invoice_id) {
        var data = {
            token:this.token,
            user_id:this.user_id,
            id: invoice_id
        }
        let responseData = <any>{};
        this.busy = this.userService.resendEmail(data).subscribe(
            response => {
                responseData = response;
                this.toastr.success(responseData.message, 'Success!');
            },
            error => {
                responseData = error;
                this.toastr.error(responseData.error.message, 'Failed!');
            }
        );
    }

    onDateChanged(event) {
        this.DateValidateSingle = "";
        if(event.formatted) {
            const currentDate = new Date(); // Get the current date
            currentDate.setHours(0, 0, 0, 0);
            const startDate = event && event.jsdate ? new Date(event.jsdate) : null;

            if (startDate <= currentDate) {
                this.DateValidateSingle = "Start date must be greater than the current date.";
                return;
            } else {
                this.DateValidateSingle = "";
            }
        }
    }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/create-invoice/create-invoice.component.ts